(() => {
  const selector = '[data-lmb-gallery-more]';
  if (window.__lmbGalleryMore) { window.__lmbGalleryMore.init(document); return; }
  const instances = new Map();
  const initialise = (root) => {
    if (instances.has(root)) return;
    const button = root.querySelector('[data-lmb-gallery-reveal]');
    if (!button) return;
    const sectionId = root.dataset.lmbGallerySection;
    const control = root.querySelector('[data-lmb-gallery-control]');
    const status = root.querySelector('[data-lmb-gallery-status]');
    let expanded = false;
    let bus = null;
    const slider = () => root.querySelector('[data-js-product-media-slider]');
    const updateSlider = (mediaId, move) => {
      const element = slider();
      const swiper = element && element.swiper;
      if (!swiper || swiper.destroyed) return;
      swiper.update();
      swiper.pagination?.render();
      swiper.pagination?.update();
      if (move) {
        const index = Array.from(swiper.slides).findIndex((slide) => String(slide.dataset.mediaId) === String(mediaId));
        if (index >= 0) swiper.slideTo(index, 0);
      }
      swiper.updateAutoHeight?.(0);
    };
    const reveal = ({ move = false, mediaId = null } = {}) => {
      const firstExtra = root.querySelector('template[data-lmb-gallery-more-slide]');
      const destination = mediaId || firstExtra?.dataset.lmbGalleryMediaId;
      let addedVideo = false;
      root.querySelectorAll('template[data-lmb-gallery-more-slide]').forEach((template) => {
        addedVideo = addedVideo || Boolean(template.content.querySelector('.js-video'));
        template.replaceWith(template.content);
      });
      root.querySelectorAll('[data-lmb-gallery-extra]').forEach((element) => { element.hidden = false; });
      root.querySelector('.lmb-product-thumbnails')?.style.setProperty('--lmb-product-media-count', root.dataset.lmbGalleryTotal);
      expanded = true;
      root.dataset.lmbGalleryExpanded = 'true';
      button.setAttribute('aria-expanded', 'true');
      if (control) control.hidden = true;
      if (status) status.textContent = status.dataset.lmbGalleryAnnouncement || '';
      updateSlider(destination, move);
      if (addedVideo) bus?.emit(`product-media:${sectionId}-update-complete`);
      if (move && destination) {
        const surface = window.matchMedia('(min-width: 1200px)').matches ? root.querySelector('.js-product-media-grid-desktop') : slider();
        const target = Array.from(surface?.querySelectorAll('[data-media-id]') || []).find((element) => String(element.dataset.mediaId) === String(destination));
        if (target) { target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true }); }
      }
    };
    const click = (event) => {
      if (!event.target.closest('[data-lmb-gallery-reveal]')) return;
      event.preventDefault();
      reveal({ move: true });
    };
    const variantChanged = ({ variant, variantId } = {}) => {
      const mediaId = variant?.featured_media?.id;
      const extra = Array.from(root.querySelectorAll('template[data-lmb-gallery-more-slide]')).find((template) => {
        if (mediaId) return String(template.dataset.lmbGalleryMediaId) === String(mediaId);
        return Array.from(template.content.querySelectorAll('[data-variant-id]')).some((element) => element.dataset.variantId.split(',').includes(String(variantId)));
      });
      if (extra) reveal({ mediaId: extra.dataset.lmbGalleryMediaId, move: true });
    };
    const refreshed = () => { if (expanded) reveal(); };
    const attach = () => {
      if (bus || !window.themeCore?.EventBus) return;
      bus = window.themeCore.EventBus;
      bus.listen(`pdp:section-${sectionId}:change-variant`, variantChanged);
      bus.listen(`product-media:${sectionId}-update-complete`, refreshed);
    };
    const observer = new MutationObserver(refreshed);
    observer.observe(root, { childList: true });
    root.addEventListener('click', click);
    document.addEventListener('theme:all:loaded', attach);
    window.addEventListener('load', attach);
    attach();
    instances.set(root, { destroy() {
      observer.disconnect();
      root.removeEventListener('click', click);
      document.removeEventListener('theme:all:loaded', attach);
      window.removeEventListener('load', attach);
      bus?.remove(`pdp:section-${sectionId}:change-variant`, variantChanged);
      bus?.remove(`product-media:${sectionId}-update-complete`, refreshed);
      instances.delete(root);
    } });
  };
  const init = (root = document) => {
    if (root.matches?.(selector)) initialise(root);
    root.querySelectorAll(selector).forEach(initialise);
  };
  window.__lmbGalleryMore = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    instances.forEach((instance, root) => { if (root === event.target || event.target.contains(root)) instance.destroy(); });
  });
})();
